import { Injectable } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { EntityFormModel } from "@app/kernel/form/classes/entity-form-model";
import { IOnFormModelInit } from "@app/kernel/form/interfaces/form-model.interfaces";
import { TControlsValue } from "@app/kernel/form/types/form-controls-utils.types";
import { IEmailControls, IEmaileDto, IEmailEntity } from "../interfaces/update-email.interface";

@Injectable()
export class EmailFormModel extends EntityFormModel<IEmailEntity, IEmaileDto, IEmailControls> implements IOnFormModelInit<IEmailControls> {
  constructor() {
    super();
  }

  onInit() {
    console.log("init");
  }

  entityToFormValue(entity?: Partial<IEmailEntity> | null): TControlsValue<IEmailControls> {
    return {
      email: entity?.email ?? "",
    };
  }

  formValueToDtoInput(formValue: TControlsValue<IEmailControls>): IEmaileDto {
    return {
      email: formValue.email,
    };
  }

  protected createFormGroup(initialValue: TControlsValue<IEmailControls>): FormGroup<IEmailControls> {
    return new FormGroup<IEmailControls>({
      email: new FormControl(initialValue.email, { nonNullable: true, validators: this.buildValidator(() => ({ isNotEmpty: {}, isEmail: {} })) }),
    });
  }
}
